import { createAction, props } from '@ngrx/store';
import {
  OdbCoverDetailDivisionType,
  IOdbCoverDetailDivisionSummaryCategories,
  IOdbBillCategoryDetailsResponse,
} from '@dch/billing-business-logic';

export const GET_ODB_CATEGORY_DETAILS_REQUEST =
  'GET_ODB_CATEGORY_DETAILS_REQUEST';
export const GET_ODB_CATEGORY_DETAILS_SUCCESS =
  'GET_ODB_CATEGORY_DETAILS_SUCCESS';
export const GET_ODB_CATEGORY_DETAILS_FAILURE =
  'GET_ODB_CATEGORY_DETAILS_FAILURE';

export const getOdbCategoryDetailsRequest = createAction(
  GET_ODB_CATEGORY_DETAILS_REQUEST,
  props<{
    billingAccountNumber: string;
    documentReference: string;
    category:
      | keyof IOdbCoverDetailDivisionSummaryCategories
      | OdbCoverDetailDivisionType;
    divisionType?: OdbCoverDetailDivisionType;
    divisionIdentifier?: string;
  }>()
);
export const getOdbCategoryDetailsSuccess = createAction(
  GET_ODB_CATEGORY_DETAILS_SUCCESS,
  props<{
    documentReference: string;
    category:
      | keyof IOdbCoverDetailDivisionSummaryCategories
      | OdbCoverDetailDivisionType;
    payload: IOdbBillCategoryDetailsResponse;
  }>()
);
export const getOdbCategoryDetailsFailure = createAction(
  GET_ODB_CATEGORY_DETAILS_FAILURE,
  props<{
    documentReference: string;
    category:
      | keyof IOdbCoverDetailDivisionSummaryCategories
      | OdbCoverDetailDivisionType;
  }>()
);
